import { createContext, useContext, useMemo } from "react";
import { useQuery } from "@tanstack/react-query";

import api from "libs/api";
import { useParams } from "react-router-dom";

const ReferralProgramContext = createContext();

const ReferralProgramProvider = ({ children }) => {
  const { id } = useParams();

  const { isLoading: loading, data } = useQuery({
    queryKey: ["referral_program", id],
    queryFn: () => api.get(!!id ? `/admin/referral/${id}` : `/client/referral`),
  });

  const value = useMemo(() => {
    return {
      data,
      loading,
      init_loading: false,
    };
  }, [data, loading]);

  return (
    <ReferralProgramContext.Provider value={value}>
      {children}
    </ReferralProgramContext.Provider>
  );
};

const useReferralProgram = () => useContext(ReferralProgramContext);
export { ReferralProgramContext, useReferralProgram };
export default ReferralProgramProvider;
